import React, {useEffect, useState} from "react";
import Spinner from "../_common/Spinner";
import DrainStationModal from "./DrainStationModal";

const DrainStationDetails = props => {
    const {station} = props;

    const [pending, setPending] = useState(true)

    useEffect(() => {
        setPending(true)
        setTimeout(() => setPending(false), 300)
    },[station])

    if(pending) {
        return (
            <div className='spinnerWrapper'>
                <Spinner size={300} />
            </div>
        )
    }

    return (
        <div className="DrainStationDetails">
            <DrainStationModal
                edit
                station={station}
                details
            />
        </div>
    )
}

export default DrainStationDetails
